import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";
import { ICreateTimeAssignmentResponse, IUpdateTimeAssignmentFormData } from "./types";

export const updateTimeAssignment = async (formData: IUpdateTimeAssignmentFormData[]): Promise<ICreateTimeAssignmentResponse> => {
  try {
    const response = await apiClientSource.put(`/task-service/api/tasks-schedule/update`, formData);
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al modificar el tiempo de la asignación");
    throw error;
  }
};
